<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.complaints && data">
  <app-popup-header title="{{localService.languageContent.complaints.new_complaint}}"></app-popup-header>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row" *ngIf="logId == ''">
      <div class="col-12">
        <input autocomplete="off" type="text" [(ngModel)]="data.v1" placeholder="{{localService.languageContent.complaints.title}}" title="{{localService.languageContent.complaints.title}}" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <textarea rows="5" [(ngModel)]="data.v2" placeholder="{{localService.languageContent.complaints.details}}" title="{{localService.languageContent.complaints.details}}"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onAdd()">{{localService.languageContent.common.add}}</button>
  </div>
</div>
